import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAttachDocumentsToElementRequestFailure(elementId) {
      const result = getState().find(
        (request) => request.elementId === elementId,
      );

      return result ? result.request.isFailure : false;
    },
    isAttachDocumentsToElementRequestPending(elementId) {
      const result = getState().find(
        (request) => request.elementId === elementId,
      );

      return result ? result.request.isPending : false;
    },
    isAttachDocumentsToElementRequestSuccess(elementId) {
      const result = getState().find(
        (request) => request.elementId === elementId,
      );

      return result ? result.request.isSuccessful : false;
    },
  };
}

export { createSelector };
